module.exports = __webpack_public_path__ + "media/about/eric-rath-4a9029b4.png";